<template>
  <div class="container-fluid mt--12">
    <actions/>
    <div class="row">
      <div class="col-sm-12 col-lg-12">
        <lista/>
      </div>
    </div>
  </div>
</template>

<script>
import LicencaPrevidenciariaListaDetalhada from "./LicencaPrevidenciariaListaDetalhada";
import LicencaPrevidenciariaActions from "./LicencaPrevidenciariaActions";
export default {
  name: "LicencaPrevidenciariaContainerLista",
  components: {
    "lista": LicencaPrevidenciariaListaDetalhada,
    "actions": LicencaPrevidenciariaActions
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/licencaPrevidenciaria/LicencaPrevidenciariaContainerLista.vue